<div class="dx-fieldset">
  <div class="dx-field">
    <div class="dx-field-label dx-field-label200">{{ 'ReferenzKataloge' | translate }}</div>
    <div class="dx-field-value inputWithPlaceHolder flex-fill w-25">
      <label class="placeLabel placeLabelSmall">{{ 'ReferenzKataloge' | translate }}</label>
      <dx-drop-down-box
        id="catalogsBox"
        [(value)]="model.refecenceCatalogs"
        valueExpr="id"
        displayExpr="catalogName"
        [showClearButton]="true"
        [dataSource]="catalogs"
        (onValueChanged)="valueChanged($event)"
      >
        <div *dxTemplate="let data of 'content'">
          <dx-data-grid
            [dataSource]="catalogs"
            keyExpr="id"
            [columns]="['catalogName']"
            [selection]="{ mode: 'multiple' }"
            [hoverStateEnabled]="true"
            [paging]="{ enabled: true, pageSize: 10 }"
            [filterRow]="{ visible: true }"
            [scrolling]="{ mode: 'infinite' }"
            [height]="345"
            [(selectedRowKeys)]="model.refecenceCatalogs"
          ></dx-data-grid>
        </div>
      </dx-drop-down-box>
    </div>
  </div>

  <div class="dx-field" style="place-content: end">
    <dx-button
      icon="description"
      text="{{ 'Wiki' | translate }}"
      stylingMode="text"
      type="default"
      (onClick)="openWikiUrl()"
    />
  </div>
</div>
